var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 30,
      height: 30,
      boxShadow: "0 0 7px #ccc",
      borderRadius: 10,
      margin: "0 10px 0 0"
    },
    viewBox: "0 0 40 41"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    y: 0.25,
    fill: "#fff",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.121 26.054A13.94 13.94 0 0 1 20 24.25c2.5 0 4.847.655 6.879 1.804M23 18.25a3 3 0 1 1-6 0 3 3 0 0 1 6 0m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
export default SvgUser;